import React, { useEffect, useState } from 'react'
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, FormFeedback } from 'reactstrap'
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { addVehicle } from 'store/actions'
import { useDispatch } from 'react-redux'
const AddNewVehicleModal = ({ showModal, setShowModal }) => {

    // const [showModal, setShowModal] = useState(false)
    const dispatch = useDispatch();
    const toggleModal = () => {
        setShowModal(!showModal)
    }
    const validation = useFormik({
        // enableReinitialize : use this  flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            brand_name: "" || "",
            model_name: "" || "",
        },
        validationSchema: Yup.object({

            brand_name: Yup.string().required("Please Enter Brand Name"),
            model_name: Yup.string().required("Please Enter Model Name"),
        }),
        onSubmit: (values) => {
            dispatch(addVehicle(values))
            validation.resetForm();
            toggleModal();
        },
    })




    return (
        <Modal isOpen={showModal} toggle={toggleModal}>
            <ModalHeader tag={"h4"} toggle={toggleModal}>
                Add New Vehicle
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                }}>
                    <FormGroup>
                        <Label for='vehicleBrandInput'>Enter Vehicle Brand</Label>
                        <Input
                            name='brand_name'
                            id='vehicleBrandInput'
                            placeholder='Enter Vehicle Brand'
                            value={validation.values.brand_name}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.brand_name &&
                                    validation.errors.brand_name
                                    ? true
                                    : false
                            }
                        />

                        {validation.touched.brand_name &&
                            validation.errors.brand_name ? (
                            <FormFeedback type="invalid">
                                {validation.errors.brand_name}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>

                    <FormGroup>
                        <Label for='vehicleModelInput'>Enter Vehicle Model</Label>
                        <Input
                            name='model_name'
                            id='vehicleModelInput'
                            placeholder='Enter Vehicle Model'
                            value={validation.values.model_name}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                                validation.touched.model_name &&
                                    validation.errors.model_name
                                    ? true
                                    : false
                            }
                        />

                        {validation.touched.model_name &&
                            validation.errors.model_name ? (
                            <FormFeedback type="invalid">
                                {validation.errors.model_name}
                            </FormFeedback>
                        ) : null}
                    </FormGroup>


                    <FormGroup>
                        <Button type='submit' color='primary'>Submit</Button>
                    </FormGroup>

                </Form>
            </ModalBody>
        </Modal>
    )
}

export default AddNewVehicleModal